var _polygon, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRvtSymbolBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Art",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 259.08 259.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "51.49 38.04 37.71 51.82 206.23 220.34 207.59 221.71 221.37 207.93 51.49 38.04"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M177.49,0H11.68C5.24,0,0,5.24,0,11.68v161.77h23.36V23.36h142.45v62.95h-26.17v23.36h37.85c6.44,0,11.68-5.24,11.68-11.68V11.68C189.16,5.24,183.93,0,177.49,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.73,86.3v150.1H93.27v-62.95h26.17v-23.36h-37.85c-6.44,0-11.68,5.24-11.68,11.68v86.31c0,6.44,5.24,11.68,11.68,11.68h165.81c6.44,0,11.68-5.24,11.68-11.68V86.3h-23.36Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRvtSymbolBlack);
export default __webpack_public_path__ + "static/media/RVT-Symbol-Black.398e8f3f2bad573996e845f5923b40ba.svg";
export { ForwardRef as ReactComponent };